module.exports = __webpack_public_path__ + "img/shouye.9d4587d4.png";